/* =========================================================
   INKSOFT DESIGNER EMBED MODULE
   Full-screen modal iframe launcher

   v5 fix:
   - Removes Open in new tab.
   - Required InkSoft launch path:
     /shop/design-studio/share/{productId}/{styleId}/{artworkId}
   - Recovers artwork/design ID from:
     config.designId / artworkId,
     launchUrl/shareUrl/selectedShareUrl,
     wrapperUrl query string,
     current URL query string,
     DOM data attributes,
     sessionStorage/localStorage.
   - Important: explicit complete /share/product/style/artwork URLs are preserved.
========================================================= */

window.InksoftPOC = window.InksoftPOC || {};

window.InksoftPOC.designerEmbed = (function () {
  var modalOpen = false;
  var MODAL_ID = 'inksoft-designer-modal-shell';
  var LOAD_TIMEOUT_MS = 22000;
  var loadTimer = null;
  var launchNonce = 0;
  var delegatedCloseBound = false;
  var reloadOnCloseConfig = null;
  var reloadOnCloseTriggered = false;
  var externalNavigationBound = false;
  var INKSOFT_ORIGIN = 'https://shop.unisourceapparel.com';

  var LOADER_STYLE_ID = 'inksoft-designer-loader-styles';
  var LOADER_PRIMARY_FILENAME = 'unisource_loader_halftone_combo.webp';
  var LOADER_FALLBACK_FILENAME = 'unisource_loader_halftone_combo.gif';
  var LOADER_MIN_VISIBLE_MS = 900;
  var loaderMessageTimer = null;
  var loaderShownAt = 0;
  var loaderMessageIndex = 0;
  var loaderImagePreloaded = false;
  var LOADER_MESSAGES = [
    'We’re ironing the apparel and preparing your workspace.',
    'Adding a gentle print-prep halftone pass.',
    'Cleaning the brushes and setting up the print area.',
    'Smoothing the fabric for your next great design.',
    'Almost ready — your design studio is loading.'
  ];

  function getDesignerAssetUrl(filename) {
    var file = asString(filename);
    if (!file) return '';

    if (window.UNISOURCE_DESIGNER_LOADER_ASSET_BASE_URL) {
      return String(window.UNISOURCE_DESIGNER_LOADER_ASSET_BASE_URL).replace(/\/$/, '') + '/' + file;
    }

    if (window.UNISOURCE_DESIGNER_LOADER_IMAGE_URL && file === LOADER_PRIMARY_FILENAME) {
      return String(window.UNISOURCE_DESIGNER_LOADER_IMAGE_URL);
    }

    try {
      var scripts = document.querySelectorAll('script[src]');
      for (var i = scripts.length - 1; i >= 0; i -= 1) {
        var src = scripts[i].getAttribute('src') || '';
        if (src.indexOf('inksoft-designer-embed') !== -1) {
          var url = new URL(src, window.location.href);
          url.pathname = url.pathname.replace(/\/[^/]*$/, '/' + file);
          url.search = '';
          url.hash = '';
          return url.toString();
        }
      }
    } catch (_error) {}

    return '/assets/' + file;
  }

  function ensureDesignerLoaderStyles() {
    if (document.getElementById(LOADER_STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = LOADER_STYLE_ID;
    style.textContent = `
      .inksoft-designer-shell__body {
        position: relative;
      }

      .inksoft-designer-loader {
        position: absolute;
        inset: 0;
        z-index: 40;
        display: none;
        align-items: center;
        justify-content: center;
        padding: 24px;
        background: rgba(255, 255, 255, 0.94);
        backdrop-filter: blur(3px);
      }

      .inksoft-designer-loader.is-active {
        display: flex;
      }

      .inksoft-designer-loader__card {
        width: min(94%, 620px);
        text-align: center;
        background: #ffffff;
        border: 1px solid rgba(20, 40, 90, 0.08);
        border-radius: 20px;
        box-shadow: 0 18px 50px rgba(18, 36, 84, 0.12);
        padding: 34px 32px 30px;
      }

      .inksoft-designer-loader__image {
        display: block;
        width: min(380px, 78vw);
        max-width: 100%;
        height: auto;
        margin: 0 auto 22px;
      }

      .inksoft-designer-loader__title {
        margin: 0 0 12px;
        color: #183153;
        font-size: 1.7rem;
        line-height: 1.3;
        font-weight: 800;
      }

      .inksoft-designer-loader__text {
        min-height: 1.5em;
        margin: 0;
        color: #4d6285;
        font-size: 1.3rem;
        line-height: 1.6;
      }

      .inksoft-designer-loader__hint {
        margin: 10px 0 0;
        color: #7a8ca8;
        font-size: 0.94rem;
        line-height: 1.55;
      }

      @media (max-width: 640px) {
        .inksoft-designer-loader {
          padding: 16px;
        }

        .inksoft-designer-loader__card {
          padding: 24px 20px 22px;
          border-radius: 16px;
        }

        .inksoft-designer-loader__image {
          width: min(300px, 76vw);
          margin-bottom: 18px;
        }

        .inksoft-designer-loader__title {
          font-size: 1.3rem;
        }

        .inksoft-designer-loader__text {
          font-size: 1rem;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function preloadDesignerLoaderImage() {
    if (loaderImagePreloaded) return;
    loaderImagePreloaded = true;

    try {
      var image = new Image();
      image.decoding = 'async';
      image.src = getDesignerAssetUrl(LOADER_PRIMARY_FILENAME);
    } catch (_error) {}
  }

  function getDesignerLoaderElements() {
    return {
      loader: document.getElementById('inksoft-designer-loader'),
      text: document.getElementById('inksoft-designer-loader-text')
    };
  }

  function setDesignerLoaderMessage(message) {
    var elements = getDesignerLoaderElements();
    if (elements.text && message) {
      elements.text.textContent = message;
    }
  }

  function showDesignerLoader(message) {
    var elements = getDesignerLoaderElements();
    var loader = elements.loader;
    var text = elements.text;

    if (!loader) return;

    loaderShownAt = Date.now();
    loaderMessageIndex = 0;

    if (text) {
      text.textContent = message || LOADER_MESSAGES[0];
    }

    loader.classList.add('is-active');
    loader.setAttribute('aria-hidden', 'false');

    if (loaderMessageTimer) {
      window.clearInterval(loaderMessageTimer);
    }

    loaderMessageTimer = window.setInterval(function () {
      loaderMessageIndex = (loaderMessageIndex + 1) % LOADER_MESSAGES.length;
      setDesignerLoaderMessage(LOADER_MESSAGES[loaderMessageIndex]);
    }, 2400);
  }

  function hideDesignerLoader(reason) {
    var elements = getDesignerLoaderElements();
    var loader = elements.loader;

    if (!loader || !loader.classList.contains('is-active')) return;

    var elapsed = loaderShownAt ? Date.now() - loaderShownAt : LOADER_MIN_VISIBLE_MS;
    var remaining = Math.max(0, LOADER_MIN_VISIBLE_MS - elapsed);

    window.setTimeout(function () {
      var latest = getDesignerLoaderElements().loader;
      if (!latest) return;

      latest.classList.remove('is-active');
      latest.setAttribute('aria-hidden', 'true');

      if (loaderMessageTimer) {
        window.clearInterval(loaderMessageTimer);
        loaderMessageTimer = null;
      }

      console.log('[Inksoft Designer Embed] Designer loader hidden', {
        reason: reason || 'hide',
        elapsedMs: Date.now() - loaderShownAt
      });
    }, remaining);
  }

  function bindDelegatedCloseHandlers() {
    if (delegatedCloseBound) return;
    delegatedCloseBound = true;

    document.addEventListener('click', function (event) {
      var target = event.target;
      var closeTarget = target && target.closest && target.closest('[data-inksoft-designer-close="true"]');

      if (closeTarget && document.getElementById(MODAL_ID)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();

        /*
          Critical: reload must happen immediately on the close click itself.
          Do not wait for iframe cleanup, iframe load/error, or other async Designer events.
        */
        if (triggerImmediateReloadOnClose('modal-close-click')) return;

        close();
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modalOpen) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();

        if (triggerImmediateReloadOnClose('escape-close')) return;

        close();
      }
    }, true);
  }

  function ensureShell() {
    bindDelegatedCloseHandlers();
    ensureDesignerLoaderStyles();
    preloadDesignerLoaderImage();
    var shell = document.getElementById(MODAL_ID);
    if (shell) return shell;

    shell = document.createElement('div');
    shell.id = MODAL_ID;
    shell.innerHTML = `
      <div class="inksoft-designer-shell__backdrop" data-inksoft-designer-close="true"></div>
      <div class="inksoft-designer-shell__dialog" role="dialog" aria-modal="true" aria-labelledby="inksoft-designer-shell-title">
        <div class="inksoft-designer-shell__header">
          <div>
            <h2 id="inksoft-designer-shell-title" class="inksoft-designer-shell__title">Design Online</h2>
            <p class="inksoft-designer-shell__subtext">Loading InkSoft Designer inside your product page shell.</p>
          </div>
          <div class="inksoft-designer-shell__controls">
            <button
              type="button"
              class="inksoft-designer-shell__close"
              data-inksoft-designer-close="true"
              aria-label="Close Designer"
              title="Close Designer"
            >✕</button>
          </div>
        </div>

        <div id="inksoft-designer-shell-status" class="inksoft-designer-shell__status">Preparing Designer...</div>

        <div class="inksoft-designer-shell__body">
          <div id="inksoft-designer-loader" class="inksoft-designer-loader" aria-live="polite" aria-hidden="true">
            <div class="inksoft-designer-loader__card">
              <picture>
                <source srcset="${getDesignerAssetUrl(LOADER_PRIMARY_FILENAME)}" type="image/webp">
                <img
                  class="inksoft-designer-loader__image"
                  src="${getDesignerAssetUrl(LOADER_FALLBACK_FILENAME)}"
                  alt="Preparing your design studio"
                  width="380"
                  height="380"
                  loading="eager"
                  decoding="async"
                >
              </picture>
              <h3 class="inksoft-designer-loader__title">Getting your design studio ready…</h3>
              <p class="inksoft-designer-loader__text" id="inksoft-designer-loader-text">We’re ironing the apparel and preparing your workspace.</p>
              <p class="inksoft-designer-loader__hint">This can take a few moments depending on the selected apparel and connection speed.</p>
            </div>
          </div>

          <div class="inksoft-designer-shell__iframe-viewport">
            <div class="inksoft-designer-shell__iframe-mask-left"></div>
            <iframe
              id="inksoft-designer-shell-iframe"
              class="inksoft-designer-shell__iframe"
              src="about:blank"
              referrerpolicy="strict-origin-when-cross-origin"
              allow="clipboard-read; clipboard-write"
            ></iframe>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(shell);

    Array.prototype.forEach.call(
      shell.querySelectorAll('[data-inksoft-designer-close="true"]'),
      function (el) {
        el.addEventListener('click', function () { close(); });
      }
    );

    /*
      The iframe is intentionally recreated for every launch by createFreshIframe().
      Reusing the same hosted InkSoft iframe can keep internal SPA/session state
      and progressively slow product/style changes.
    */

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modalOpen) close();
    });

    return shell;
  }

  function setStatus(message, isError) {
    var el = document.getElementById('inksoft-designer-shell-status');
    if (!el) return;
    el.textContent = message || '';
    el.classList.toggle('is-error', !!isError);
  }

  function getIframeViewport(shell) {
    return shell ? shell.querySelector('.inksoft-designer-shell__iframe-viewport') : null;
  }

  function createFreshIframe(shell) {
    var viewport = getIframeViewport(shell);
    if (!viewport) return null;

    clearTimeout(loadTimer);
    loadTimer = null;

    /*
      Full reset:
      Remove the previous iframe instead of only changing src to about:blank.
      This clears the hosted Designer's in-frame SPA state and prevents
      previous product/style/color sessions from affecting the next launch.
    */
    viewport.innerHTML = '<div class="inksoft-designer-shell__iframe-mask-left"></div>';

    var iframe = document.createElement('iframe');
    iframe.id = 'inksoft-designer-shell-iframe';
    iframe.className = 'inksoft-designer-shell__iframe';
    iframe.src = 'about:blank';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.setAttribute('allow', 'clipboard-read; clipboard-write');

    iframe.addEventListener('load', function () {
      if (!modalOpen) return;

      var currentSrc = iframe.getAttribute('src') || '';
      if (!currentSrc || currentSrc === 'about:blank') return;

      clearTimeout(loadTimer);
      setStatus('Designer loaded in embedded mode.', false);
      hideDesignerLoader('iframe-load');
    });

    viewport.appendChild(iframe);

    return iframe;
  }

  function getReloadOnCloseUrl() {
    if (!reloadOnCloseConfig || !reloadOnCloseConfig.enabled) return '';

    if (reloadOnCloseConfig.url) {
      return String(reloadOnCloseConfig.url || '');
    }

    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('designId');
      url.searchParams.delete('designID');
      url.searchParams.delete('artworkId');
      url.searchParams.delete('artworkID');
      url.searchParams.delete('designImageUrl');
      url.searchParams.delete('artworkImageUrl');
      url.searchParams.delete('previewImageUrl');
      url.searchParams.delete('designName');
      url.searchParams.set('_designerReset', String(Date.now()));
      return url.toString();
    } catch (_error) {
      return window.location.href;
    }
  }

  function scheduleReloadOnClose(reason) {
    const reloadUrl = getReloadOnCloseUrl();
    if (!reloadUrl) return;

    console.log('[Inksoft Designer Embed] Reloading product page after Designer close', {
      reason: reason || 'modal-close',
      url: reloadUrl
    });

    setStatus('Resetting Designer session...', false);

    window.setTimeout(function () {
      window.location.replace(reloadUrl);
    }, 350);
  }

  function triggerImmediateReloadOnClose(reason) {
    if (reloadOnCloseTriggered) return false;

    const reloadUrl = getReloadOnCloseUrl();
    if (!reloadUrl) return false;

    reloadOnCloseTriggered = true;

    console.log('[Inksoft Designer Embed] Immediate product page reload from modal close click', {
      reason: reason || 'modal-close-click',
      url: reloadUrl
    });

    try {
      setStatus('Resetting Designer session...', false);
    } catch (_error) {}

    /*
      Use href instead of replace during testing so the reload is immediate and visible.
      This avoids waiting for iframe cleanup/load events that can be delayed by InkSoft.
    */
    window.location.href = reloadUrl;

    return true;
  }

  function hardReset(reason) {
    var shell = document.getElementById(MODAL_ID);
    var iframe = document.getElementById('inksoft-designer-shell-iframe');
    var viewport = getIframeViewport(shell);

    launchNonce += 1;

    clearTimeout(loadTimer);
    loadTimer = null;
    modalOpen = false;

    /*
      Strong reset:
      1. Stop the current remote document.
      2. Remove src/srcdoc.
      3. Remove the iframe node entirely.
      4. Rebuild the viewport placeholder.
    */
    if (iframe) {
      try {
        iframe.onload = null;
        iframe.src = 'about:blank';
        iframe.removeAttribute('src');
        iframe.removeAttribute('srcdoc');
      } catch (error) {
        console.warn('[Inksoft Designer Embed] iframe pre-remove cleanup skipped.', error);
      }

      if (iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
    }

    if (viewport) {
      viewport.innerHTML = '<div class="inksoft-designer-shell__iframe-mask-left"></div>';
    }

    if (shell) {
      shell.classList.remove('is-open');
      shell.setAttribute('aria-hidden', 'true');
    }

    document.body.style.overflow = '';
    hideDesignerLoader('hard-reset');
    setStatus('Preparing Designer...', false);

    try {
      document.dispatchEvent(new CustomEvent('unisource:designer-reset', {
        bubbles: true,
        detail: {
          reason: reason || 'manual-reset',
          launchNonce: launchNonce
        }
      }));
    } catch (_error) {}

    console.log('[Inksoft Designer Embed] HARD RESET Designer iframe', {
      reason: reason || 'manual-reset',
      launchNonce: launchNonce
    });

    if (
      reloadOnCloseConfig &&
      reloadOnCloseConfig.enabled &&
      (
        reason === 'modal-close' ||
        reason === 'close' ||
        reason === 'escape-close' ||
        reason === 'backdrop-close'
      )
    ) {
      scheduleReloadOnClose(reason);
    }
  }

  function asString(value) {
    return value == null ? '' : String(value).trim();
  }

  function normalizeInksoftUrl(url) {
    var value = asString(url);
    if (!value) return '';

    value = value.replace(/\/Unisource_Apparel\/Unisource_Apparel\//g, '/Unisource_Apparel/');

    if (/^https?:\/\//i.test(value)) return value;
    if (value.indexOf('/Unisource_Apparel/') === 0) return 'https://shop.unisourceapparel.com' + value;
    if (value.indexOf('/shop/') === 0) return 'https://shop.unisourceapparel.com/Unisource_Apparel' + value;

    return value;
  }

  function isAllowedExternalNavigationUrl(value) {
    var url = safeUrl(value);
    if (!url) return false;

    if (url.origin !== INKSOFT_ORIGIN) {
      return false;
    }

    var path = String(url.pathname || '').toLowerCase();

    return (
      path.indexOf('/shop/cart') !== -1 ||
      path.indexOf('/shopping-cart') !== -1 ||
      path.indexOf('/shop/account') !== -1 ||
      path.indexOf('/shop/my-account') !== -1 ||
      path.indexOf('/shop/myaccount') !== -1 ||
      path.indexOf('/account') !== -1 ||
      path.indexOf('/my-account') !== -1 ||
      path.indexOf('/myaccount') !== -1
    );
  }

  function handleExternalNavigationMessage(event) {
    if (!event || event.origin !== INKSOFT_ORIGIN) return;

    var data = event.data || {};

    if (data.type !== 'unisource:inksoft-external-navigation') {
      return;
    }

    var destination = normalizeInksoftUrl(data.url || '');

    if (!isAllowedExternalNavigationUrl(destination)) {
      console.warn('[Inksoft Designer Embed] Blocked external navigation message.', {
        origin: event.origin,
        url: destination
      });
      return;
    }

    console.log('[Inksoft Designer Embed] Opening InkSoft route outside modal.', {
      url: destination
    });

    hardReset('external-navigation');
    window.location.assign(destination);
  }

  function bindExternalNavigationMessages() {
    if (externalNavigationBound) return;
    externalNavigationBound = true;

    window.addEventListener('message', handleExternalNavigationMessage, false);

    console.log('[Inksoft Designer Embed] External Cart/Account navigation listener installed.');
  }

  function getStoreBase() {
    return 'https://shop.unisourceapparel.com/Unisource_Apparel';
  }

  function getFirstValue(source, keys) {
    if (!source) return '';

    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      var value = '';

      if (source instanceof URLSearchParams) {
        value = asString(source.get(key));
      } else {
        value = asString(source[key]);
      }

      if (value) return value;
    }

    return '';
  }

  function safeUrl(value) {
    var raw = asString(value);
    if (!raw) return null;

    try {
      return raw.indexOf('http') === 0
        ? new URL(raw)
        : new URL(raw, window.location.origin);
    } catch (_error) {
      return null;
    }
  }

  function getParamsFromUrl(value) {
    var url = safeUrl(value);
    return url ? url.searchParams : new URLSearchParams();
  }

  function extractShareParts(url) {
    var value = asString(url);
    var match = value.match(/\/shop\/design-studio\/share\/([^/?#]+)\/([^/?#]+)(?:\/([^/?#]+))?/i);

    if (!match) {
      return { productId: '', styleId: '', artworkId: '' };
    }

    return {
      productId: decodeURIComponent(match[1] || ''),
      styleId: decodeURIComponent(match[2] || ''),
      artworkId: decodeURIComponent(match[3] || '')
    };
  }

  function isCompleteShareUrl(url) {
    return /\/shop\/design-studio\/share\/[^/]+\/[^/]+\/[^/?#]+/i.test(asString(url));
  }

  function getConfigUrls(config) {
    config = config || {};

    return [
      config.launchUrl,
      config.shareUrl,
      config.selectedShareUrl,
      config.href,
      config.url,
      config.wrapperUrl
    ]
      .map(normalizeInksoftUrl)
      .filter(Boolean);
  }

  function getFromConfigUrlParams(config, keys) {
    var urls = getConfigUrls(config);

    for (var i = 0; i < urls.length; i += 1) {
      var value = getFirstValue(getParamsFromUrl(urls[i]), keys);
      if (value) return value;
    }

    return '';
  }

  function getFromShareUrlParts(config, partName) {
    var urls = getConfigUrls(config);

    for (var i = 0; i < urls.length; i += 1) {
      var parts = extractShareParts(urls[i]);
      if (parts && parts[partName]) return parts[partName];
    }

    return '';
  }

  function getFromDom(keys) {
    var selectors = [
      '[data-artwork-id]',
      '[data-design-id]',
      '[data-inksoft-design-id]',
      '[data-selected-design-id]',
      '[data-current-design-id]',
      '[data-template-design-id]',
      '[data-design-online]',
      '[data-inksoft-designer-launch]'
    ];

    for (var s = 0; s < selectors.length; s += 1) {
      var nodes = document.querySelectorAll(selectors[s]);

      for (var n = 0; n < nodes.length; n += 1) {
        var node = nodes[n];

        var direct =
          asString(node.getAttribute('data-artwork-id')) ||
          asString(node.getAttribute('data-design-id')) ||
          asString(node.getAttribute('data-inksoft-design-id')) ||
          asString(node.getAttribute('data-selected-design-id')) ||
          asString(node.getAttribute('data-current-design-id')) ||
          asString(node.getAttribute('data-template-design-id'));

        if (direct) return direct;

        for (var k = 0; k < keys.length; k += 1) {
          var key = keys[k];
          var attrName = 'data-' + key.replace(/[A-Z]/g, function (m) {
            return '-' + m.toLowerCase();
          });

          var value =
            asString(node.getAttribute(attrName)) ||
            asString(node.dataset ? node.dataset[key] : '');

          if (value) return value;
        }
      }
    }

    return '';
  }

  function getFromStorage(keys) {
    var stores = [];

    try { stores.push(window.sessionStorage); } catch (_error) {}
    try { stores.push(window.localStorage); } catch (_error) {}

    for (var s = 0; s < stores.length; s += 1) {
      var store = stores[s];

      for (var i = 0; i < store.length; i += 1) {
        var storageKey = store.key(i);
        var storageValue = asString(store.getItem(storageKey));

        if (!storageValue) continue;

        var haystack = (storageKey + ' ' + storageValue).toLowerCase();

        if (
          haystack.indexOf('design') === -1 &&
          haystack.indexOf('artwork') === -1 &&
          haystack.indexOf('inksoft') === -1
        ) {
          continue;
        }

        for (var k = 0; k < keys.length; k += 1) {
          var key = keys[k];
          var regex = new RegExp('"' + key + '"\\s*:\\s*"?([0-9A-Za-z_-]+)"?', 'i');
          var match = storageValue.match(regex);
          if (match && match[1]) return match[1];
        }

        var looseMatch = storageValue.match(/(?:designId|artworkId|inksoftDesignId|selectedDesignId)["'=:\s]+([0-9A-Za-z_-]+)/i);
        if (looseMatch && looseMatch[1]) return looseMatch[1];
      }
    }

    return '';
  }

  function getCurrentPageParams() {
    try {
      return new URLSearchParams(window.location.search || '');
    } catch (_error) {
      return new URLSearchParams();
    }
  }

  function getProductId(config) {
    var keys = ['productId', 'productID', 'ProductId', 'ProductID', 'id'];

    return (
      getFirstValue(config, keys) ||
      getFromConfigUrlParams(config, keys) ||
      getFirstValue(getCurrentPageParams(), keys) ||
      getFromShareUrlParts(config, 'productId')
    );
  }

  function getStyleId(config) {
    var keys = ['styleId', 'productStyleId', 'ProductStyleId', 'styleID', 'StyleID'];

    return (
      getFirstValue(config, keys) ||
      getFromConfigUrlParams(config, keys) ||
      getFirstValue(getCurrentPageParams(), keys) ||
      getFromShareUrlParts(config, 'styleId')
    );
  }

  function getArtworkId(config) {
    var keys = [
      'artworkId',
      'artworkID',
      'ArtworkId',
      'ArtworkID',
      'artId',
      'designId',
      'designID',
      'DesignId',
      'DesignID',
      'mappedDesignId',
      'finalDesignId',
      'selectedDesignId',
      'templateDesignId',
      'inksoftDesignId'
    ];

    return (
      getFirstValue(config, keys) ||
      getFromConfigUrlParams(config, keys) ||
      getFirstValue(getCurrentPageParams(), keys) ||
      getFromShareUrlParts(config, 'artworkId') ||
      getFromDom(keys) ||
      getFromStorage(keys)
    );
  }

  function getExplicitCompleteShareUrl(config) {
    var urls = getConfigUrls(config);

    for (var i = 0; i < urls.length; i += 1) {
      if (isCompleteShareUrl(urls[i])) return urls[i];
    }

    return '';
  }

  function buildShareDesignerUrl(config) {
    var productId = getProductId(config);
    var styleId = getStyleId(config);
    var artworkId = getArtworkId(config);

    if (!productId || !styleId) return '';

    var url =
      getStoreBase() +
      '/shop/design-studio/share/' +
      encodeURIComponent(productId) +
      '/' +
      encodeURIComponent(styleId);

    if (artworkId) {
      url += '/' + encodeURIComponent(artworkId);
    }

    return url;
  }

  function isDesignerQueryUrl(url) {
    return /\/shop\/design-studio\/design(?:\?|#|$)/i.test(asString(url));
  }

  function isDesignerShareUrl(url) {
    return /\/shop\/design-studio\/share\//i.test(asString(url));
  }

  function isProductStyleOnlyShareUrl(url) {
    var parts = extractShareParts(url);
    return Boolean(parts && parts.productId && parts.styleId && !parts.artworkId);
  }

  function getExplicitArtworkIdFromConfigOnly(config) {
    var keys = [
      'artworkId',
      'artworkID',
      'ArtworkId',
      'ArtworkID',
      'artId',
      'designId',
      'designID',
      'DesignId',
      'DesignID',
      'mappedDesignId',
      'finalDesignId',
      'selectedDesignId',
      'templateDesignId',
      'inksoftDesignId'
    ];

    return (
      getFirstValue(config, keys) ||
      getFromConfigUrlParams(config, keys) ||
      getFromShareUrlParts(config, 'artworkId')
    );
  }

  function resolveLaunchUrl(config) {
    config = config || {};

    var urls = getConfigUrls(config);
    var explicitFallbackUrl = urls[0] || '';
    var explicitCompleteShareUrl = getExplicitCompleteShareUrl(config);

    /*
      Critical blank-launch fix:
      When product page sends a query-style /design-studio/design URL with no
      explicit artwork/design ID, preserve that exact URL and DO NOT recover
      artwork IDs from DOM, current URL, sessionStorage, or localStorage.

      The previous v5 embed recovered a design ID from page artifacts and
      converted blank launches into /share/product/style/artwork, causing the
      first Design Ideas artwork to load even when the customer did not select it.
    */
    if (
      explicitFallbackUrl &&
      isDesignerQueryUrl(explicitFallbackUrl) &&
      !getExplicitArtworkIdFromConfigOnly(config)
    ) {
      var queryParams = getParamsFromUrl(explicitFallbackUrl);

      return {
        url: explicitFallbackUrl,
        strategy: 'explicit-designer-query-url-no-artwork',
        productId: getFirstValue(config, ['productId', 'productID', 'ProductId', 'ProductID', 'id']) ||
          getFirstValue(queryParams, ['productId', 'productID', 'ProductId', 'ProductID', 'id']),
        styleId: getFirstValue(config, ['styleId', 'productStyleId', 'ProductStyleId', 'styleID', 'StyleID']) ||
          getFirstValue(queryParams, ['styleId', 'productStyleId', 'ProductStyleId', 'styleID', 'StyleID']),
        artworkId: ''
      };
    }

    /*
      Critical blank-launch fix:
      When product page sends an explicit /share/{productId}/{styleId} URL
      with no artwork/design ID, preserve that exact URL and DO NOT recover
      artwork IDs from DOM, current URL, sessionStorage, or localStorage.

      Without this guard, the embed layer can accidentally pick up the first
      Design Ideas artwork and convert a blank launch into an artwork launch.
    */
    if (
      explicitFallbackUrl &&
      isDesignerShareUrl(explicitFallbackUrl) &&
      isProductStyleOnlyShareUrl(explicitFallbackUrl) &&
      !getExplicitArtworkIdFromConfigOnly(config)
    ) {
      var shareOnlyParts = extractShareParts(explicitFallbackUrl);

      return {
        url: explicitFallbackUrl,
        strategy: 'explicit-share-product-style-no-artwork',
        productId: shareOnlyParts.productId,
        styleId: shareOnlyParts.styleId,
        artworkId: ''
      };
    }

    var productId = getProductId(config);
    var styleId = getStyleId(config);
    var artworkId = getArtworkId(config);
    var generatedShareUrl = buildShareDesignerUrl(config);

    /*
      Preserve an already complete InkSoft share URL first.
      This prevents the modal from downgrading a valid /product/style/artwork
      launchUrl into product/style only.
    */
    if (explicitCompleteShareUrl) {
      var explicitParts = extractShareParts(explicitCompleteShareUrl);

      return {
        url: explicitCompleteShareUrl,
        strategy: 'explicit-complete-share-url',
        productId: productId || explicitParts.productId,
        styleId: styleId || explicitParts.styleId,
        artworkId: artworkId || explicitParts.artworkId
      };
    }

    if (productId && styleId && artworkId && generatedShareUrl) {
      return {
        url: generatedShareUrl,
        strategy: 'generated-product-style-artwork-share-url',
        productId: productId,
        styleId: styleId,
        artworkId: artworkId
      };
    }

    /*
      Product/style-only share URLs are now a last resort. For blank product
      launches, prefer the explicit query-style Designer URL whenever supplied.
    */
    if (explicitFallbackUrl && isDesignerQueryUrl(explicitFallbackUrl)) {
      return {
        url: explicitFallbackUrl,
        strategy: 'explicit-designer-query-url-fallback',
        productId: productId,
        styleId: styleId,
        artworkId: ''
      };
    }

    if (generatedShareUrl) {
      return {
        url: generatedShareUrl,
        strategy: 'generated-share-url-product-style-only',
        productId: productId,
        styleId: styleId,
        artworkId: artworkId
      };
    }

    if (explicitFallbackUrl) {
      return {
        url: explicitFallbackUrl,
        strategy: 'explicit-fallback-url',
        productId: productId,
        styleId: styleId,
        artworkId: artworkId
      };
    }

    return {
      url: '',
      strategy: 'missing-launch-values',
      productId: productId,
      styleId: styleId,
      artworkId: artworkId
    };
  }

  function startLoadTimer() {
    clearTimeout(loadTimer);

    loadTimer = window.setTimeout(function () {
      if (!modalOpen) return;
      setStatus('InkSoft Designer is still loading. Please wait a little longer.', false);
      setDesignerLoaderMessage('Still preparing the Designer — thanks for waiting.');
    }, LOAD_TIMEOUT_MS);
  }

  function open(config) {
    var shell = ensureShell();
    var launch = resolveLaunchUrl(config || {});
    var finalUrl = launch.url;
    var iframe = null;

    console.log('[Inksoft Designer Embed] Resolved launch values:', {
      productId: launch.productId,
      styleId: launch.styleId,
      artworkId: launch.artworkId,
      strategy: launch.strategy,
      url: finalUrl,
      config: config || {}
    });

    if (!shell) {
      console.error('[Inksoft Designer Embed] Modal shell could not be created.');
      return;
    }

    if (!finalUrl) {
      console.error('[Inksoft Designer Embed] Missing launch URL, productId, or styleId.', config);
      setStatus('Unable to launch Designer because the required launch values are incomplete.', true);
      return;
    }

    if (!launch.artworkId && !isCompleteShareUrl(finalUrl)) {
      console.warn('[Inksoft Designer Embed] Artwork ID was not found. Designer will open product/style only.', {
        config: config || {},
        currentUrl: window.location.href
      });
    }

    /*
      Always start from a clean hosted Designer iframe.
      This is the reset that keeps repeated color/style launches from piling
      onto the previous InkSoft iframe state.
    */
    iframe = createFreshIframe(shell);

    if (!iframe) {
      console.error('[Inksoft Designer Embed] Designer iframe could not be created.');
      return;
    }

    launchNonce += 1;
    var currentLaunchNonce = launchNonce;

    shell.classList.add('is-open');
    shell.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    modalOpen = true;

    setStatus(
      launch.artworkId || isCompleteShareUrl(finalUrl)
        ? 'Loading InkSoft Designer with selected artwork...'
        : 'Loading selected product and color...',
      false
    );

    showDesignerLoader(
      launch.artworkId || isCompleteShareUrl(finalUrl)
        ? 'We’re setting up your selected artwork and apparel.'
        : 'We’re ironing the apparel and preparing your workspace.'
    );

    window.setTimeout(function () {
      if (currentLaunchNonce !== launchNonce) return;
      iframe.src = finalUrl;
      startLoadTimer();
    }, 60);
  }

  function close() {
    hardReset('modal-close');
  }

  function setReloadOnClose(config) {
    reloadOnCloseTriggered = false;

    reloadOnCloseConfig = Object.assign({
      enabled: false,
      url: ''
    }, config || {});

    console.log('[Inksoft Designer Embed] Reload-on-close config updated', reloadOnCloseConfig);
  }

  function reset(reason) {
    hardReset(reason || 'external-reset');
  }

  bindExternalNavigationMessages();

  return {
    open: open,
    close: close,
    reset: reset,
    setReloadOnClose: setReloadOnClose,
    resolveLaunchUrl: resolveLaunchUrl
  };
})();